export default `/payment/`;